import _classCallCheck from "/home/ubuntu/dev/moloch-monorepo/packages/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/ubuntu/dev/moloch-monorepo/packages/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import uuid from 'uuid/v4';

var SafeSubprovider =
/*#__PURE__*/
function () {
  function SafeSubprovider() {
    _classCallCheck(this, SafeSubprovider);
  }

  _createClass(SafeSubprovider, [{
    key: "sendTransaction",
    value: function sendTransaction(payload, end) {
      var id = uuid();
      payload.params[0].id = id;
      var showPopupEvent = new window.CustomEvent('EV_SHOW_POPUP_TX', {
        detail: payload.params[0]
      });
      window.dispatchEvent(showPopupEvent);

      var resolveTransactionHandler = function resolveTransactionHandler(data) {
        window.removeEventListener('EV_RESOLVED_TRANSACTION' + data.detail.id, resolveTransactionHandler);

        if (data.detail.hash) {
          end(null, data.detail.hash);
        } else {
          end(new Error('Transaction rejected', data.detail.id));
        }
      };

      window.addEventListener('EV_RESOLVED_TRANSACTION' + id, resolveTransactionHandler);
    }
  }, {
    key: "signTypedData",
    value: function signTypedData(payload, end) {
      var showPopupSignEvent = new window.CustomEvent('EV_SHOW_POPUP_SIGNATURE', {
        detail: payload.params
      });
      window.dispatchEvent(showPopupSignEvent);

      var signedTypedDataHandler = function signedTypedDataHandler(data) {
        window.removeEventListener('EV_RESOLVED_WALLET_SIGN_TYPED_DATA', signedTypedDataHandler);

        if (data.detail.walletSignature) {
          end(null, data.detail.walletSignature);
        } else {
          end(new Error('Signature rejected'));
        }
      };

      window.addEventListener('EV_RESOLVED_WALLET_SIGN_TYPED_DATA', signedTypedDataHandler);
    }
  }, {
    key: "handleRequest",
    value: function handleRequest(payload, next, end) {
      var account = this.engine.currentSafe;

      switch (payload.method) {
        case 'eth_accounts':
          end(null, account ? [account] : []);
          return;

        case 'eth_coinbase':
          end(null, account);
          return;

        case 'eth_sendTransaction':
          this.sendTransaction(payload, end);
          return;

        case 'wallet_signTypedData':
          this.signTypedData(payload, end);
          return;

        default:
          next();
      }
    }
  }, {
    key: "setEngine",
    value: function setEngine(engine) {
      this.engine = engine;
    }
  }]);

  return SafeSubprovider;
}();

export default SafeSubprovider;